import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeBy',
  pure: true,
  standalone: false,
})
export class ExcludeByPipe implements PipeTransform {
  transform<T extends Record<string, any>>(
    items: T[] | null | undefined,
    excludedValue: any,
    key: keyof T = 'id' as keyof T,
  ): T[] {
    if (!items || !items.length) return items ?? [];

    if (excludedValue === null || excludedValue === undefined || excludedValue === 0) {
      return items;
    }

    return items.filter((item) => item[key] !== excludedValue);
  }
}
